import type { AvailableActionOption, Game } from '../../types/game'
import { Worker } from '../shared/Worker'
import { MobileFlowerTile } from './MobileFlowerTile'

interface MobileFlowerMarketPanelProps {
  game: Game
  availableActions: AvailableActionOption[]
  activePanel: string | null
  onForage: (flowerId: number) => void
  onClose: () => void
}

export function MobileFlowerMarketPanel({
  game,
  availableActions,
  activePanel,
  onForage,
  onClose,
}: MobileFlowerMarketPanelProps) {
  return (
    <div id="mobile-flower-market" className={`mobile-panel modal-panel mobile-flower-market${activePanel === 'flowers' ? ' open' : ''}`}>
      <div className="mobile-panel-shell">
        <div className="mobile-panel-header">
          <div className="mobile-panel-title-main">Forage</div>
          <div id="mobile-market-forager-pool" className="mobile-market-forager-pool">
            {game.foragers.map((color, index) => (
              <Worker key={`${color}-${index}`} color={color} />
            ))}
          </div>
          <div id="mobile-close-flowers" className="mobile-panel-close lobby-start" onClick={onClose}>Close</div>
        </div>
        <div id="mobile-market-flower-grid" className="mobile-flower-grid">
          {game.flower_market.map((flower) => (
            <MobileFlowerTile
              key={flower.id}
              flower={flower}
              currentSeason={game.current_season}
              onClick={() => onForage(flower.id)}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
